export default __webpack_public_path__ + "static/media/prev-button.22721051.svg";